module.exports = __webpack_public_path__ + "img/amazon.a8c55c37.png";